import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  back?: boolean;
  actions?: React.ReactNode;
}

export function PageHeader({ eyebrow, title, description, back = false, actions }: PageHeaderProps) {
  const navigate = useNavigate();

  return (
    <header className="page-header">
      <div className="page-header__top">
        <div className="page-header__title-row">
          {back && (
            <button className="icon-button" type="button" onClick={() => navigate(-1)} aria-label="Назад">
              <ChevronLeft size={22} />
            </button>
          )}
          <div>
            {eyebrow && <div className="eyebrow">{eyebrow}</div>}
            <h1>{title}</h1>
          </div>
        </div>
        {actions && <div className="page-header__actions">{actions}</div>}
      </div>
      {description && <p>{description}</p>}
    </header>
  );
}
